const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/plan/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PlanStatus } from '@/lib/api/types/adaptivePlanner';
import { getPlanByLoopIdQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlanByLoopIdQuery';
import { isHttpError } from '@/lib/utils/common/isHttpError';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/plan/')({
  loader: async ({
    context: {
      queryClient
    },
    params: {
      loopId,
      org
    }
  }) => {
    try {
      const plan = await queryClient.ensureQueryData(getPlanByLoopIdQueryOptions({
        loopId
      }));
      if (plan) {
        if (plan.status === PlanStatus.ScenarioGenerated || plan.status === PlanStatus.Activated) {
          throw redirect({
            to: '/org/$org/loop/$loopId/plan/$planId/scenario-timeline',
            params: {
              org,
              loopId,
              planId: plan.id
            }
          });
        }
        throw redirect({
          to: '/org/$org/loop/$loopId/plan/$planId/scope-refinement',
          params: {
            org,
            loopId,
            planId: plan.id
          }
        });
      }
    } catch (error) {
      if (isHttpError(error, 404)) {
        return;
      }
      throw error;
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});